/**
 * Global-leaderboard note shown while any match is live. The global order stays
 * on settled points until full-time (only the squad leaderboard re-ranks live),
 * so this explains that a moving "+N live" on a card without the rank changing is
 * intentional.
 */

import React, { useMemo } from 'react';
import { View, Text } from 'react-native';
import { Activity } from 'lucide-react-native';
import { useTheme } from '../../../src/theme/useTheme';
import { LEADERBOARD_VIEW_COPY } from './LeaderboardView.constants';
import { getLeaderboardLiveRankingNoteStyles } from './LeaderboardLiveRankingNote.styles';

export const LeaderboardLiveRankingNote: React.FC = () => {
  const theme = useTheme();
  const styles = useMemo(() => getLeaderboardLiveRankingNoteStyles(theme), [theme]);

  return (
    <View style={styles.banner}>
      <Activity size={15} color={theme.success} />
      <Text style={styles.text}>{LEADERBOARD_VIEW_COPY.LIVE_RANKING_NOTE}</Text>
    </View>
  );
};
